import React from 'react';
import { motion } from 'framer-motion';
import { Cookie } from 'lucide-react';

const BUTTON_INITIAL = { scale: 0, opacity: 0 };
const BUTTON_ANIMATE = { scale: 1, opacity: 1 };
const BUTTON_EXIT = { scale: 0, opacity: 0 };
const BUTTON_HOVER = { scale: 1.1 };
const BUTTON_TAP = { scale: 0.95 };

const CookieFloatingButton = ({ onClick }) => {
  return (
    <motion.button
      initial={BUTTON_INITIAL}
      animate={BUTTON_ANIMATE}
      exit={BUTTON_EXIT}
      whileHover={BUTTON_HOVER}
      whileTap={BUTTON_TAP}
      onClick={onClick}
      className="fixed bottom-6 right-6 z-50 p-4 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg hover:shadow-xl transition-all"
      aria-label="Cookie Settings"
      data-testid="cookie-floating-btn"
    >
      <Cookie className="w-6 h-6" />
    </motion.button>
  );
};

export default CookieFloatingButton;
